import { dexieStorage } from './dexie-storage';
import { queueOps } from './runtime';

export async function clearLocalData(): Promise<void> {
  await dexieStorage.clearAll();
}

export async function clearPendingOnly(): Promise<void> {
  await queueOps.clearQueue();
}
